/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, effect, input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { ValidationFunction, ValidatorSchema } from './schema.model';

@Directive({
  selector: '[iriroValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomValidatorDirective,
      multi: true,
    }
  ],
  standalone: true,
})
export class CustomValidatorDirective implements Validator {
  validationFunctions = input<
    ValidatorSchema<any> | ValidationFunction<any> | ValidationFunction<any>[] | undefined | null
  >([], {
    alias: 'iriroValidator',
  });

  control: AbstractControl | undefined = undefined;

  constructor() {
    effect(() => {
      if (!this.validationFunctions()) {
        this.control?.updateValueAndValidity();
      } else {
        this.control?.updateValueAndValidity();
      }
    });
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;
    const validationFunctions = this.validationFunctions();
    if (!validationFunctions || validationFunctions.length === 0) {
      return null;
    }

    if (typeof validationFunctions === 'function' || Array.isArray(validationFunctions)) {
      const errors: ValidationErrors = {};

      if (Array.isArray(validationFunctions)) {
        for (const validator of validationFunctions) {
          const result = validator(control.value);
          if (result) {
            Object.assign(errors, result);
          }
        }
      } else {
        const result = validationFunctions(control.value);
        if (result) {
          Object.assign(errors, result);
        }
      }
      return Object.keys(errors).length ? errors : null;
    } else {
      const validatorsSchema = <ValidatorSchema<any>>validationFunctions;
      if (validatorsSchema.$cross) {
        const validators = Array.isArray(validatorsSchema.$cross) ? validatorsSchema.$cross : [validatorsSchema.$cross];
        let errors = {};
        validators.forEach((validator) => {
          errors = { ...errors, ...validator(control.value) };
        });
        return errors;
      }
      return null;
    }
  }
}
